export default "__VITE_ASSET__5v6IRi3G__"